import React from 'react'

export default function Footer() {
  return (
    <div className="w-full footer">
      <div className="mxw-lg grid gap-6 grid-cols-1 text-center footer_bar py-12">
          <div>
            <p className="blog_text">Get in touch </p>
            <p><a className='blog_text' href="mailto:stmeem@yahoo.com">stmeem@yahoo.com</a></p>
          </div>
          
          
      </div>
    </div>
  )
}
